"use strict";

import React from 'react';

function SvgLeavePageIcon({color = '#000000', size = '16', style={}}) {
    return (
        <svg  xmlns="http://www.w3.org/2000/svg" width={size} height={size} style={style} viewBox="0 0 70 70">
            <g>
                <path className="st0" fill={color}
                      d="M52.3,59.7H14.2c-1.1,0-2.1-0.9-2.1-2V19.6c0-1.1,0.9-2.1,2.1-2.1h17c1.1,0,2,0.9,2,2.1c0,1.1-0.9,2-2,2h-15
                v34h34V40.7c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v16.9C54.4,58.8,53.4,59.7,52.3,59.7z"/>
                <path className="st1" fill={color} stroke={color} strokeWidth="0.1" strokeMiterlimit="10"
                      d="M59,13c0,0-19.2,0.1-19.2,0l6.9,6.9L26.1,40.5c-1.5,1.5-1.5,4,0,5.5c0.8,0.8,1.8,1.1,2.8,1.1
                c1,0,2-0.4,2.8-1.1l20.6-20.6l6.8,6.8V13z"/>
            </g>
        </svg>
    );
}

export default SvgLeavePageIcon;